import { AccountModelDto, CompanyAccountModelDto } from '@treasury/api/bo';
import { DomainEntity } from '@treasury/domain/shared';

const defaultAccount: CompanyAccountModelDto = {
    id: 0,
    updatedBy: '',
    updatedDate: '',
    name: 'accountNameJeff',
    number: '098321313',
    status: '',
    account: {
        id: 0,
        number: '',
        type: '',
        coreStatus: '',
        isCompanyAccount: false,
        linkedTMCompanies: [],
    } as AccountModelDto,
    type: 'Checking',
    perTransactionLimit: 0,
    dailyLimit: 0,
    cifNumber: '',
    accountUniqueId: '',
};

export class BillingAccountEntity extends DomainEntity<CompanyAccountModelDto> {
    public static createDefault(): BillingAccountEntity {
        return new BillingAccountEntity(defaultAccount);
    }

    /**
     * tracks whether the account is linked to the current transaction code
     */
    public active = false;

    /**
     * tracks the account table selection state
     */
    public selected = false;

    public createDefault(): this {
        return new BillingAccountEntity(defaultAccount) as this;
    }

    public get accountNumber(): string {
        return this.dto.number || '';
    }

    public get type(): string {
        return this.dto.type || '';
    }

    public get name(): string {
        return this.dto.name || '';
    }

    public get isLinked(): boolean {
        return (this.dto.account?.linkedTMCompanies?.length || 0) > 0;
    }

    public get number() {
        return this.dto.number;
    }

    public get id() {
        return this.dto.id;
    }

    public get accountId() {
        return this.dto.account?.id || 0;
    }
}
